import { images } from '../../../Constants/ImageUrls';
import { clickedCardEvent, clickedCtaEvent } from '../utils/instrumentation';
import {
  CurrentWeekDiv,
  GrowthWeekDiv,
  GrowthWeekList,
  GrowthWeeks,
} from './styled';

export default function ScrollableWeeks(props) {
  const { currentWeek, setCurrentWeek, location } = props;
  const onChangeWeek = (
    count,
    enable = true,
    card = false,
    dontSetCurrentWeek = false,
  ) => {
    if (enable) {
      if (!dontSetCurrentWeek) {
        setCurrentWeek((prevState) => prevState + count);
      }
      if (card) {
        clickedCardEvent('Growth Tracker', `Week ${currentWeek + count}`);
      } else {
        let cta_text = count == 1 ? 'clicked_next' : 'clicked_prev';
        clickedCtaEvent(cta_text, 'Growth Tracker');
      }
    }
  };
  const weeks = [-2, -1, 0, 1, 2];
  const checkWeek = (week) => {
    return week >= 4 && week <= 42;
  };
  return (
    <GrowthWeeks>
      <div
        className="rightArrow"
        onClick={() => onChangeWeek(-1, checkWeek(currentWeek - 1))}
        style={
          checkWeek(currentWeek - 1) ? { opacity: '1' } : { opacity: '0.4' }
        }
      >
        <img src={images.white_arrow} alt="" />
      </div>
      {weeks.map((week, index) => {
        return week == 0 ? (
          <GrowthWeekDiv>
            <GrowthWeekList
              className="active"
              key={index}
              as={location ? 'h1' : 'li'}
            >
              {currentWeek} WEEKS PREGNANT{' '}
            </GrowthWeekList>
            <CurrentWeekDiv>(Current Week)</CurrentWeekDiv>
          </GrowthWeekDiv>
        ) : (
          <a
            href={`/parenting/pregnancy/week-${currentWeek + week}`}
            key={index}
          >
            <GrowthWeekList
              onClick={() => onChangeWeek(week, true, true, true)}
              className={checkWeek(currentWeek + week) ? 'show' : 'hide'}
            >
              {currentWeek + week} WEEK
            </GrowthWeekList>
          </a>
        );
      })}
      <div
        className="leftArrow"
        onClick={() => onChangeWeek(1, checkWeek(currentWeek + 1))}
        style={
          checkWeek(currentWeek + 1) ? { opacity: '1' } : { opacity: '0.4' }
        }
      >
        {' '}
        <img src={images.white_arrow} alt="" />
      </div>
    </GrowthWeeks>
  );
}
